// Home.jsx
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

export default function Home() {
  const [activeTab, setActiveTab] = useState("injectable");
  const [currentPracticeIndex, setCurrentPracticeIndex] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  // Sample product data for tabs
  const productsData = {
    injectable: [
      { name: "BOLDA 300", manufacturer: "Anabolic Pharma", pack: "10 ml vial (300 mg/ml)" },
  { name: "TEST-E 300", manufacturer: "Anabolic Pharma", pack: "10 ml vial (300 mg/ml)" },
  { name: "DECA 350", manufacturer: "Anabolic Pharma", pack: "10 ml vial (350 mg/ml)" },
  { name: "NPP 100", manufacturer: "Anabolic Pharma", pack: "10 ml vial (100 mg/ml)" },
  { name: "TEST-C 300", manufacturer: "Anabolic Pharma", pack: "10 ml vial (300 mg/ml)" },
  { name: "TREN-A 100", manufacturer: "Anabolic Pharma", pack: "10 ml vial (100 mg/ml)" },
  { name: "PRIMO 100", manufacturer: "Anabolic Pharma", pack: "10 ml vial (100 mg/ml)" },
  { name: "SUSTANON 400", manufacturer: "Anabolic Pharma", pack: "10 ml vial (400 mg/ml)" },
  { name: "WINSTROL 100", manufacturer: "Anabolic Pharma", pack: "10 ml vial (100 mg/ml)" },
  { name: "MASTERON 100", manufacturer: "Anabolic Pharma", pack: "10 ml vial (100 mg/ml)" },
  { name: "TEST-P 100", manufacturer: "Anabolic Pharma", pack: "10 ml vial (100 mg/ml)" },
  { name: "TREN-E 200", manufacturer: "Anabolic Pharma", pack: "10 ml vial (200 mg/ml)" },
    ],
    oral: [
      { name: "ANADROL 50MG", manufacturer: "Anabolic Pharma", pack: "100 tabs bottle" },
      { name: "ANAVAR 10MG", manufacturer: "Anabolic Pharma", pack: "100 tabs bottle" },
      { name: "CLEN 40MCG", manufacturer: "Anabolic Pharma", pack: "100 tabs bottle" },
      { name: "DBOL 10MG", manufacturer: "Anabolic Pharma", pack: "100 tabs bottle" },
      { name: "STANA 10MG", manufacturer: "Anabolic Pharma", pack: "100 tabs bottle" },
      { name: "T3 40MCG", manufacturer: "Anabolic Pharma", pack: "100 tabs bottle" },
    ],
    all: []
  };

  // Combine all products for "ALL" tab
  productsData.all = [...productsData.injectable, ...productsData.oral];

  const practiceImages = [
    { img: "/assets/home/practice_1.png", title: "Quality control institute" },
    { img: "/assets/home/practice_2.png", title: "Quality control institute" },
    { img: "/assets/home/practice_3.png", title: "Quality control institute" },
    { img: "/assets/home/practice_1.png", title: "Quality control institute" },
    { img: "/assets/home/practice_2.png", title: "Quality control institute" },
    { img: "/assets/home/practice_3.png", title: "Quality control institute" },
    { img: "/assets/home/practice_1.png", title: "Quality control institute" },
    { img: "/assets/home/practice_2.png", title: "Quality control institute" },
    { img: "/assets/home/practice_3.png", title: "Quality control institute" },
  ];

  // Auto-slide for practice box
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPracticeIndex((prev) => (prev + 1) % practiceImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Scroll to top button visibility
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const nextPractice = () => {
    setCurrentPracticeIndex((prev) => (prev + 1) % practiceImages.length);
  };

  const prevPractice = () => {
    setCurrentPracticeIndex((prev) => (prev - 1 + practiceImages.length) % practiceImages.length);
  };

  return (
    <div className="home-page min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      
      {/* Hero Section - Top Box */}
      <div className="top-box relative bg-gradient-to-r from-blue-900 to-purple-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="container mx-auto px-4 py-16 md:py-24 relative z-10">
          <div className="fixed-box max-w-7xl mx-auto">
            <div className="top-content text-center">
              <h4 className="text-xl md:text-2xl font-semibold mb-2 animate-fade-in-up">
                BUILD YOUR BODY
              </h4>
              <h3 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent animate-fade-in-up">
                STRONG
              </h3>
              <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8 text-gray-200 animate-fade-in-up">
                Anabolic pharma has most of its production facilities in germany.
                The company produces a wide range of human grade pharmaceutical in
                dosage forms including capsules, tablets and liquid.
              </p>
              <Link to="/qualification" className="view-more inline-block px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300 animate-fade-in-up">
                View More
              </Link>

              {/* Banner List - Three Cards */}
              <div className="banner-list grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
                {/* Injectable Steroids Card */}
                <div className="banner-list-item bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300">
                  <div className="injector w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">INJECTABLE STEROIDS</h3>
                  <p className="text-sm text-gray-200 mb-4">
                    100% Authentication System Warranty 100% satisfaction guarantee
                  </p>
                  <Link to="/products" className="view-more inline-block px-4 py-2 bg-white/20 rounded-lg hover:bg-white/30 transition-colors text-sm">
                    View More
                  </Link>
                </div>

                {/* Oral Steroids Card */}
                <div className="banner-list-item bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300">
                  <div className="pill w-16 h-16 bg-gradient-to-r from-green-600 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">ORAL STEROIDS</h3>
                  <p className="text-sm text-gray-200 mb-4">
                    100% Authentication System Warranty 100% satisfaction guarantee
                  </p>
                  <Link to="/products" className="view-more inline-block px-4 py-2 bg-white/20 rounded-lg hover:bg-white/30 transition-colors text-sm">
                    View More
                  </Link>
                </div>

                {/* ALL Products Card */}
                <div className="banner-list-item bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300">
                  <div className="dna w-16 h-16 bg-gradient-to-r from-orange-600 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">ALL</h3>
                  <p className="text-sm text-gray-200 mb-4">
                    100% Authentication System Warranty 100% satisfaction guarantee
                  </p>
                  <Link to="/products" className="view-more inline-block px-4 py-2 bg-white/20 rounded-lg hover:bg-white/30 transition-colors text-sm">
                    View More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Practice Box - Good Manufacturing Practice */}
      <div className="practice-box py-16 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="fixed-box max-w-7xl mx-auto">
            <div className="practice-box-title flex justify-between items-center mb-8 flex-wrap gap-4">
              <h3 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                Good Manufacturing Practice
              </h3>
              <div className="practice-list-controller flex gap-2">
                <button
                  onClick={prevPractice}
                  className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-blue-600 hover:text-white transition-colors flex items-center justify-center"
                >
                  ←
                </button>
                <button
                  onClick={nextPractice}
                  className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-blue-600 hover:text-white transition-colors flex items-center justify-center"
                >
                  →
                </button>
              </div>
            </div>
            <div className="practice-box-list overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-out"
                style={{ transform: `translateX(-${currentPracticeIndex * 100}%)` }}
              >
                {practiceImages.map((item, idx) => (
                  <div key={idx} className="practice-box-list-item w-half flex-shrink-0 px-4">
                    <div className="bg-gray-100 dark:bg-gray-700 rounded-2xl overflow-hidden shadow-lg">
                      <img src={item.img} alt={item.title} className="w-half h-64 object-cover" />
                      <div className="p-4 text-center">
                        <p className="font-semibold text-gray-800 dark:text-white">{item.title}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <div className="about-us relative bg-gradient-to-r from-blue-900 to-purple-900 text-white py-20">
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="fixed-box max-w-7xl mx-auto text-center">
            <div className="about-us-des">
              <h4 className="text-2xl font-bold mb-2">A-PHARMA</h4>
              <h3 className="text-3xl md:text-4xl font-bold mb-6">
                Anabolic Pharma Company is a WHO Certified Pharmaceutical Company...
              </h3>
              <Link to="/qualification" className="inline-block px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300">
                ABOUT US
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Products Tabs Section */}
      <div className="product-tabs py-16 bg-gray-50 dark:bg-gray-900" id="products-tab">
        <div className="container mx-auto px-4">
          <div className="fixed-box max-w-7xl mx-auto">
            <h3 className="product-tabs-title text-4xl font-bold text-center mb-8 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              OUR PRODUCTS
            </h3>
            
            {/* Tabs Bar */}
            <div className="product-tabs-bar flex justify-between items-center mb-8 flex-wrap gap-4">
              <ul className="tabs-bar-tab flex gap-2">
                {["injectable", "oral", "all"].map((tab) => (
                  <li key={tab}>
                    <button
                      onClick={() => setActiveTab(tab)}
                      className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${
                        activeTab === tab
                          ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg"
                          : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:shadow-md"
                      }`}
                    >
                      {tab === "injectable" ? "Injectable steroids" : tab === "oral" ? "Oral steroids" : "ALL"}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Products Table */}
            <div className="product-tabs-body bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <tbody>
                    {productsData[activeTab].map((product, idx) => (
                      <tr key={idx} className="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                        <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">{product.name}</td>
                        <td className="px-6 py-4 text-gray-600 dark:text-gray-300">{product.manufacturer}</td>
                        <td className="px-6 py-4 text-gray-600 dark:text-gray-300">{product.pack}</td>
                        <td className="px-6 py-4">
                          <Link to="/products" className="view-more text-blue-600 hover:text-blue-700 font-semibold">
                            View More →
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quality Box Section */}
      <div className="quality-box py-16 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="quality-box-container max-w-7xl mx-auto">
            <div className="quality-box-content">
              <div className="fixed-box flex flex-col lg:flex-row gap-8 items-center">
                <img 
                  src="/assets/home/quality_left.png" 
                  alt="quality_left"
                  className="w-full lg:w-1/2 rounded-2xl shadow-xl"
                />
                <div className="quality-des lg:w-1/2">
                  <div className="quality-des-bar flex items-center gap-4 mb-6">
                    <img src="/assets/logo/logo.png" alt="logo" className="h-12" />
                    <p className="text-xl font-bold text-gray-800 dark:text-white">
                      Anabolic Pharma Qualification ISO 9001 Certified
                    </p>
                  </div>
                  <div className="space-y-4 text-gray-600 dark:text-gray-300">
                    <p>
                      Each of our products is produced in our current Good
                      Manufacturing Practice (GMP) facility to ensure optimum
                      quality. Anabolic pharma company also complies with the ISO
                      9001 standards to ensure that all aspects of our activity meet
                      the highest quality standards.
                    </p>
                    <p>
                      The quality check begins with the incoming raw material, is
                      passed on in production and ends with the delivery of the
                      finished product. Strict controls, carried out according to
                      legal requirements and standards-specific, accompany the
                      product...
                    </p>
                  </div>
                  <ul className="quality-des-footer flex gap-6 my-6">
                    <li className="flex items-center gap-2">
                      <div className="diamond w-6 h-6 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full"></div>
                      <span className="text-gray-700 dark:text-gray-300">Premium quality</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <div className="shield w-6 h-6 bg-gradient-to-r from-green-600 to-teal-600 rounded-full"></div>
                      <span className="text-gray-700 dark:text-gray-300">Engineered for performance</span>
                    </li>
                  </ul>
                  <Link to="/qualification" className="view-more inline-block px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:shadow-xl transition-all duration-300">
                    view more →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Go to Top Button */}
      {isScrolled && (
        <button
          onClick={scrollToTop}
          className="goup fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-50 flex items-center justify-center animate-bounce"
        >
          ↑
        </button>
      )}
    </div>
  );
}